// extracted by mini-css-extract-plugin
export default {"page":"wY-z","cartModal":"xY-z","checkout":"yY-z","placeholder":"zY-z","account":"AY-z"};